import BPIconButton from 'components/BionicUI/icons/BPIconButton';
import BPMuteToggleButton from 'components/BionicUI/muteToggleButton/BPMuteToggleButton';
import { cn } from 'lib/utils';
import { FC, ReactNode } from 'react';

interface InputBarProps {
  children?: ReactNode;
  fadeUp?: boolean;
  gridClass?: boolean;
  showBackButton?: boolean;
  onClickBackButton?: () => void;
}

const InputBar: FC<InputBarProps> = ({
  children = null,
  fadeUp = true,
  showBackButton = true,
  gridClass = false,
  onClickBackButton = () => {},
}) => {
  const fadeUpClass = fadeUp ? 'animate-fade-up' : '';

  return (
    <div className="grid md:grid-cols-[56px_644px_56px] gap-[18px] relative w-full md:justify-center items-start page-side-padding">
      <div className="grid h-[72px] place-items-center" />

      <div
        className={cn(
          `grid grid-rows-[auto_40px] ${gridClass ? 'md:grid-rows-[auto_40px]' : 'md:grid-rows-[72px_40px]'} gap-[12px]`,
          fadeUpClass
        )}
      >
        {children ?? <></>}
      </div>

      <div
        className={cn(
          'grid h-[72px] grid-flow-col md:place-items-center md:justify-normal',
          showBackButton ? 'justify-between' : 'justify-end'
        )}
      >
        {showBackButton && (
          <div className="md:absolute md:-ml-[1475px]">
            <BPIconButton icon="backArrow" onClick={onClickBackButton} />
          </div>
        )}
        <BPMuteToggleButton />
      </div>
    </div>
  );
};

export default InputBar;
